/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPlaidInstitutions} from '../api'

 export const useQueryGetPlaidInstitutions = createReactQueryHook('getPlaidInstitutions', getPlaidInstitutions)
